import { render, staticRenderFns } from "./datastore-detail-item.vue?vue&type=template&id=351269ce&scoped=true&"
import script from "./datastore-detail-item.vue?vue&type=script&lang=js&"
export * from "./datastore-detail-item.vue?vue&type=script&lang=js&"
import style0 from "./datastore-detail-item.vue?vue&type=style&index=0&id=351269ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351269ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VProgressLinear,VTextField})
